module.exports = __webpack_public_path__ + "img/expand.3d7d7d4a.svg";